/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container{margin:10px 0}.loader{position:absolute;top:10%;left:50%}.nonPublicLayerList{overflow:auto;max-height:150px}"];
export { styles as styles };
